function ManageButtonArea(props: any) {
  let myProps = {
    handlePrint: () => { },
    print_options: {},
    set_print_options: (inData: any) => { },
    get_todo_info_arr_by_ajax: (inData: any) => { },
    ...props
  };
  let print_options = myProps.print_options;

  const on_change_print_option = (inData: any) => {
    let name = inData.target.name;
    let value = inData.target.value;
    if (inData.target.type === "checkbox") {
      if (inData.target.checked) {
        value = "1";
      } else {
        value = "";
      }
    }
    if (name == "is_print_stu_name"||name=="is_reverse") {
      if (value == "1") {
        value = true;
      } else {
        value = false;
      }
    }
    if(name=="is_reverse"){
      myProps.get_todo_info_arr_by_ajax({
        is_reverse: value
      });
    }
    let new_print_options = { ...print_options };
    new_print_options[name] = value;
    myProps.set_print_options(new_print_options);
  };

  return (
    <div className="my_flex_center">
      <button className="btn btn-dark" onClick={() => { myProps.handlePrint(); }}>프린트</button>
      <span>반복:</span>
      <select className="row-input" value={print_options.repeat_cnt} name="repeat_cnt"
        onChange={on_change_print_option} style={{ width: "80px" }} >
        <option value="5">5회</option>
        <option value="10">10회</option>
        <option value="15">15회</option>
        <option value="20">20회</option>
      </select>

      <span>단어장</span>
      <select className="row-input" value={print_options.print_templete} name="print_templete"
        onChange={on_change_print_option} style={{ width: "70px" }} >
        <option value="box">박스</option>
        <option value="line">라인</option>
      </select>

      <label>
        <input type="checkbox" className="ml-1" name="is_print_stu_name" value={""} checked={print_options.is_print_stu_name}
          onChange={on_change_print_option} />
        <span className="ml-1">학생 이름</span>
      </label>
      <label>
        <input type="checkbox" className="ml-1" name="is_print_word" value={""} checked={print_options.is_print_word}
          onChange={on_change_print_option} />
        <span className="ml-1">단어</span>
      </label>
      <label>
        <input type="checkbox" className="ml-1" name="is_print_mean" value={""} checked={print_options.is_print_mean}
          onChange={on_change_print_option} />
        <span className="ml-1">뜻</span>
      </label>
      <label>
        <input type="checkbox" className="ml-1" name="is_reverse" value={""} checked={print_options.is_reverse}
          onChange={on_change_print_option} />
        <span className="ml-1">날짜역순</span>
      </label>
    </div>
  );
};
export default ManageButtonArea;